<template>
  <div v-wechat-title="$route.meta.title">
    <router-view></router-view>
    <div
      v-if="isWeiXin"
      class="no-weixin flex items-center justify-center w-full h-full"
    >
      <div class="noWx-desc">请您在微信环境访问该链接</div>
    </div>
  </div>
</template>
<script setup>
import { isWeixin } from './common/utils'
import { ref } from 'vue'
import 'vant/es/popup/style'
const isWeiXin = ref(!isWeixin())
</script>

<style lang="less">
#app {
  min-height: 100vh;
  width: 7.5rem;
  color: #333;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  background: #f7f7f7;
}

</style>
